export default "__VITE_ASSET__bad80310__$_?component__"